import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { TEXT } from '../../config/guestReviewLabels';

/**
 * The turnover clean behind a row, opened in place (the page owns the dialog). Its photos and the
 * cleaner's answer are the evidence ops scores a «لا» from, and it is where a late clean gets chased.
 */
const TaskLinkButton = ({ taskId, ticketId, onOpen, loading }) => (
  <Button
    variant="link"
    className="gr-link gr-task-link"
    onClick={() => onOpen(taskId)}
    disabled={!taskId || loading}
  >
    {loading
      ? <Spinner animation="border" size="sm" />
      : <i className="bi bi-clipboard-check" aria-hidden="true"></i>}
    {' '}{TEXT.openTask}
    {ticketId && <> <span dir="ltr">{ticketId}</span></>}
  </Button>
);

export default TaskLinkButton;
